import { useEffect } from "react";

import { useTypedQuery } from "hooks";
import { KeyLockersQueryKeys } from "modules/KeyLockersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useKeyLockerDetailsQuery = (keylocker_id: number | null) => {
  const query = useTypedQuery({
    queryKey: KeyLockersQueryKeys.keyLockerDetails,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { keylocker_id }, baseUrl)).data.keylocker_boxes,
    enabled: Boolean(keylocker_id)
  });

  useEffect(() => {
    if (keylocker_id) query.refetch();
  }, [keylocker_id]);

  return query;
};
